import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

function Body({
  children, scrollable, overflow, maxHeight,
}) {
  return (
    <div
      style={{
        overflow,
        maxHeight,
      }}
      className={cns(
        'modal--body',
        {
          'modal--body--scrollable': scrollable,
        },
      )}
    >
      {children}
    </div>
  );
}

Body.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Assegna la classe scrollable al componente */
  scrollable: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  /** Altezza massima  */
  maxHeight: PropTypes.string,
  /** Proprietà di overflow da personalizzare */
  overflow: PropTypes.string,
};

Body.defaultProps = {
  children: null,
  scrollable: null,
  maxHeight: null,
  overflow: null,
};

export default Body;
